import React, { useState } from "react";
import { Button, Typography, Divider, Space, Tag } from "antd";
import { unEnrollTotpFactor } from "../UserSlice";
import { useIntl } from "react-intl";
import store from "../../../redux/store";
import { firebaseApp } from "../../../api/auth";
import EnrollTotpModal from "./EnrollTotpModal";
const { Title, Text } = Typography;

const EnrollTotp = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const intl = useIntl();
  const currentUser = firebaseApp.auth().currentUser;
  const showModal = () => {
    setIsModalOpen(true);
  };

  const hasEnrolledTotpFactor = currentUser?.multiFactor?.enrolledFactors.some(
    (factor) => factor.factorId === "totp"
  );
  return (
    <>
      <div style={{ width: "100%" }}>
        <Divider />
        <Space>
          <Title level={5} style={{ margin: 0 }}>
            {intl.formatMessage({
              id: "app.twoFactor.twoFactorTitle",
            })}
          </Title>
          {hasEnrolledTotpFactor && (
            <Tag color="green">
              {intl.formatMessage({
                id: "app.twoFactor.activated",
              })}
            </Tag>
          )}
        </Space>

        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text>
            {intl.formatMessage({
              id: "app.twoFactor.twoFactorSubTitle",
            })}
          </Text>

          {hasEnrolledTotpFactor ? (
            <Button danger onClick={() => store.dispatch(unEnrollTotpFactor())}>
              {intl.formatMessage({
                id: "app.twoFactor.unEnroll",
              })}
            </Button>
          ) : (
            <Button type="primary" onClick={showModal}>
              {intl.formatMessage({
                id: "app.twoFactor.activate",
              })}
            </Button>
          )}
        </div>
      </div>
      <EnrollTotpModal
        visible={isModalOpen}
        hideModal={() => setIsModalOpen(false)}
      />
    </>
  );
};
export default EnrollTotp;
